export { BvlVideoComponent as BvlVideo } from './video.component';
export { BvlVideoModule } from './video.module';
